export default __webpack_public_path__ + "assets/images/02ae1cc4232957bcd627758c9f01acf7.png";